"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDescription = exports.getTextEditorData = exports.getDescriptionTypeByLanguage = exports.isDescriptionFieldSection = exports.textEditorLangMapper = void 0;
var TextEditor_1 = require("../constants/TextEditor");
var textEditorLangMapper = function (textEditor) {
    return TextEditor_1.TEXT_EDITOR_LANGUAGES[textEditor];
};
exports.textEditorLangMapper = textEditorLangMapper;
var isDescriptionFieldSection = function (row) {
    return (row.hasOwnProperty('description') ||
        row.hasOwnProperty('description_ru') ||
        row.hasOwnProperty('description_en'));
};
exports.isDescriptionFieldSection = isDescriptionFieldSection;
var getDescriptionTypeByLanguage = function (lang) {
    var descriptionType = Object.keys(TextEditor_1.TEXT_EDITOR_LANGUAGES).find(function (key) { return TextEditor_1.TEXT_EDITOR_LANGUAGES[key] === lang; });
    return descriptionType;
};
exports.getDescriptionTypeByLanguage = getDescriptionTypeByLanguage;
var getTextEditorData = function (path) {
    var textEditorData = {
        subjectName: '',
        translationDirection: '',
        subjectIndex: null,
    };
    // Getting description subject name (building or apartment),
    // translation direction (what language to translate)
    // and apartment index (if there are many apartments)
    var subject = path.split('.');
    if (subject[0].includes('[')) {
        // if for example subjectData === apartment_info[0].description
        textEditorData.subjectName = subject[0].split('[')[0];
        textEditorData.subjectIndex = parseInt(subject[0].split('[')[1]);
    }
    else {
        // if for example subjectData === building_info.description
        textEditorData.subjectName = subject[0];
    }
    textEditorData.translationDirection = subject[1];
    return textEditorData;
};
exports.getTextEditorData = getTextEditorData;
var getDescription = function (currentLanguage, description, description_ru, description_en) {
    switch (currentLanguage) {
        case 'hy':
            return description;
        case 'ru':
            return description_ru;
        case 'en':
            return description_en;
        default:
            return '';
    }
};
exports.getDescription = getDescription;
